<template>
  <div>
    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{locales && locales.properties && locales.properties.dependant_leave_area }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end'>
        <div>
          <theme-numeric
            v-model="leaveArea['own_room'].surface"
            name='leaveArea[own_room][surface]'
            :label='locales && locales.properties && locales.properties.private_rooms_surface'
            @input='countDependantLeaveAreaPoints(leaveArea)'
            :IsExtraInfo='true'
          >
            <template slot='extra-info'> m<sup>2</sup></template>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="leaveArea['common_area'].surface"
            name='leaveArea[common_area][surface]'
            :label='locales && locales.properties && locales.properties.common_area_at_same_address'
            @input='countDependantLeaveAreaPoints(leaveArea)'
            :IsExtraInfo='true'
          >
            <template slot='extra-info'> m<sup>2</sup></template>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="leaveArea['number_of_residents']"
            name='leaveArea[number_of_residents]'
            :label='locales && locales.properties && locales.properties.number_of_residents'
            @input='countDependantLeaveAreaPoints(leaveArea)'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='leaveArea.total'
            name='leaveArea[total]'
            :label='totalLabel(locales && locales.properties && locales.properties.leave_area)'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{locales && locales.properties && locales.properties.dependant_other_spaces_area }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end'>
        <div>
          <theme-numeric
            v-model="otherSpaces['private_other_spaces'].surface"
            name='otherSpaces[private_other_spaces][surface]'
            :label='locales && locales.properties && locales.properties.private_other_rooms_surface'
            @input='countDependantOtherSpacesAreaPoints(otherSpaces)'
            :IsExtraInfo='true'
          >
            <template slot='extra-info'> m<sup>2</sup></template>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="otherSpaces['common_other_spaces_area'].surface"
            name='otherSpaces[common_other_spaces_area][surface]'
            :label='locales && locales.properties && locales.properties.common_other_spaces_area_at_same_address'
            @input='countDependantOtherSpacesAreaPoints(otherSpaces)'
            :IsExtraInfo='true'
          >
            <template slot='extra-info'> m<sup>2</sup></template>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="otherSpaces['number_of_residents']"
            name='otherSpaces[number_of_residents]'
            :label='locales && locales.properties && locales.properties.number_of_residents'
            @input='countDependantOtherSpacesAreaPoints(otherSpaces)'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='otherSpaces.total'
            name='otherSpaces[total]'
            :label='totalLabel(locales && locales.properties && locales.properties.other_spaces)'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.heating_and_cooling }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end'>
        <div>
          <theme-numeric
            v-model="heating.private_rooms_with_heating.value"
            name='heating[private_rooms_with_heating]'
            :label="`${locales && locales.properties && locales.properties.private_rooms_with_heating} ${heating.private_rooms_with_heating.value ? heating.private_rooms_with_heating.total : ''}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="heating.private_rooms_with_cooling.value"
            name='heating[private_rooms_with_cooling]'
            :label="`${locales && locales.properties && locales.properties.private_rooms_with_cooling} ${heating.private_rooms_with_cooling.value ? heating.private_rooms_with_cooling.total : ''}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end'>
        <div>
          <theme-numeric
            v-model="heating['number_of_residents']"
            name='heating[number_of_residents]'
            :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="heating.shared_rooms_with_heating.value"
            name='heating[shared_rooms_with_heating]'
            :label="`${locales && locales.properties && locales.properties.shared_rooms_with_heating} ${heating.shared_rooms_with_heating.value ? heating.shared_rooms_with_heating.total : ''}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="heating.shared_rooms_with_cooling.value"
            name='heating[shared_rooms_with_cooling]'
            :label="`${locales && locales.properties && locales.properties.shared_rooms_with_cooling} ${heating.shared_rooms_with_cooling.value ? heating.shared_rooms_with_cooling.total : ''}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end'>
        <div>
          <theme-numeric
            v-model="heating.private_other_spaces_with_heating.value"
            name='heating[private_other_spaces_with_heating]'
            :label="`${locales && locales.properties && locales.properties.private_other_spaces_with_heating} ${heating.private_other_spaces_with_heating.value ? heating.private_other_spaces_with_heating.total : ''}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end'>
        <div>
          <theme-numeric
            v-model="heating['number_of_other_spaces_residents']"
            name='heating[number_of_other_spaces_residents]'
            :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model="heating.shared_other_spaces_with_heating.value"
            name='heating[shared_other_spaces_with_heating]'
            :label="`${locales && locales.properties && locales.properties.shared_other_spaces_with_heating} ${heating.shared_other_spaces_with_heating.value ? heating.shared_other_spaces_with_heating.total : ''}`"
            @input='countHeatingPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='heating.total'
            name='heating[total]'
            :label='totalLabel(locales && locales.properties && locales.properties.heated_private_rooms)'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.energy_performance }}
      </h2>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.energy_label }}
          <strong v-if="energy.energy_label && energyLabels[energy.energy_label] && energyLabels[energy.energy_label]['slug'] != 'no_label_or_index'">
            {{ energy.energy_points || '' }}
          </strong>
        </h3>
        <div class='mb-10'>
          <theme-radios
            v-model='energy.energy_label'
            name='energy[energy_label]'
            :options='energyLabelsOptions'
            :sort='true'
            sort-by='custom'
            :custom-order='energyLabelsCustomOrder'
            @input='countEnergyPoints'>
          </theme-radios>
        </div>
        <div v-if="energy.energy_label && energyLabels[energy.energy_label] && energyLabels[energy.energy_label]['slug'] == 'no_label_or_index'" class='grid grid-cols-1 lg:grid-cols-12'>
          <div class='col-span-4'>
            <theme-input
              @input='countEnergyPoints'
              :label="`${locales &&locales.properties && locales.properties.construction_year} ${energy.building_construction_year && energy.energy_points || ''}`"
              v-model='energy.building_construction_year'
              name='energy[building_construction_year]'>
            </theme-input>
          </div>
        </div>
      </div>
      <div class='mb-5'>
        <input type='hidden' name='energy[monument_allowance]' value='0'/>
        <theme-checkboxes
          id='monumentAllowance'
          @input='countEnergyPoints'
          label=''
          :is-single-checkbox='true'
          name='energy[monument_allowance]'
          v-model='energy.monument_allowance'
          :options="{ '1': `${locales && locales.properties && locales.properties.monument_allowance_energy}` }">
        </theme-checkboxes>
        <template v-if='energy.monument_allowance == 1'>
          <input type='hidden' name='energy[monument_allowance]' value='1'/>
        </template>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='energy.total'
            valid-scope='modal-form'
            name='energy[total]'
            :label='locales && locales.properties && locales.properties.total_energy'
            :precision='2'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.kitchen }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model="kitchen['number_of_residents']"
            name='kitchen[number_of_residents]'
            :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
            @input='countKitchenPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.worktop_length }}
            <strong v-if='kitchen.worktop_length.value'>{{ kitchen.worktop_length.total || '' }}</strong>
          </h3>
          <theme-radios
            :columnDirection='true'
            v-model='kitchen.worktop_length.value'
            name='kitchen[worktop_length]'
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.less_than_1_meter,
              '2':
                locales &&
                locales.properties &&
                locales.properties['1_2_meters'],
              '3':
                locales &&
                locales.properties &&
                locales.properties['2_3_meters'],
              '4':
                locales &&
                locales.properties &&
                locales.properties.more_than_3_meters,
              '5':
                locales &&
                locales.properties &&
                locales.properties.more_than_5_meters,
            }"
            @input='countKitchenPoints'>
          </theme-radios>
        </div>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.cooker }}
            <strong v-if='kitchen.cooker.value'>{{ kitchen.cooker.total || '' }}</strong>
          </h3>
          <theme-radios
            :columnDirection='true'
            v-model='kitchen.cooker.value'
            name='kitchen[cooker]'
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_gas_hob,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_ceramic_hob,
              '3':
                locales &&
                locales.properties &&
                locales.properties.built_in_induction_hob,
            }"
            @input='countKitchenPoints'>
          </theme-radios>
        </div>
        <div>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.oven }}
            <strong v-if='kitchen.oven.value'>{{ kitchen.oven.total || '' }}</strong>
          </h3>
          <theme-radios
            :columnDirection='true'
            v-model='kitchen.oven.value'
            name='kitchen[oven]'
            :options="{
              '1':
                locales &&
                locales.properties &&
                locales.properties.built_in_gas_oven,
              '2':
                locales &&
                locales.properties &&
                locales.properties.built_in_electric_oven,
            }"
            @input='countKitchenPoints'>
          </theme-radios>
        </div>
      </div>
      <div class='mb-10'>
        <div class='grid grid-cols-1 lg:grid-cols-5 gap-5'>
          <div>
            <input type='hidden' name='kitchen[built_in_microwave]' value='0'/>
            <theme-checkboxes
              id='built_in_microwave'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_microwave]'
              v-model='kitchen.built_in_microwave.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_microwave} ${kitchen.built_in_microwave.value == 1 ? kitchen.built_in_microwave.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_extractor_hood]' value='0'/>
            <theme-checkboxes
              id='built_in_extractor_hood'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_extractor_hood]'
              v-model='kitchen.built_in_extractor_hood.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_extractor_hood} ${kitchen.built_in_extractor_hood.value == 1 ? kitchen.built_in_extractor_hood.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_fridge]' value='0'/>
            <theme-checkboxes
              id='built_in_fridge'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_fridge]'
              v-model='kitchen.built_in_fridge.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_fridge} ${kitchen.built_in_fridge.value == 1 ? kitchen.built_in_fridge.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_freezer]' value='0'/>
            <theme-checkboxes
              id='built_in_freezer'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_freezer]'
              v-model='kitchen.built_in_freezer.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_freezer} ${kitchen.built_in_freezer.value == 1 ? kitchen.built_in_freezer.total : ''}` }">
            </theme-checkboxes>
          </div>
          <div>
            <input type='hidden' name='kitchen[built_in_dishwasher]' value='0'/>
            <theme-checkboxes
              id='built_in_dishwasher'
              @input='countKitchenPoints'
              label=''
              :is-single-checkbox='true'
              name='kitchen[built_in_dishwasher]'
              v-model='kitchen.built_in_dishwasher.value'
              :options="{ '1': `${locales && locales.properties && locales.properties.built_in_dishwasher} ${kitchen.built_in_dishwasher.value == 1 ? kitchen.built_in_dishwasher.total : ''}` }">
            </theme-checkboxes>
          </div>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-numeric
            v-model='kitchen.luxury_mixer_tap.value'
            valid-scope='modal-form'
            name='kitchen[luxury_mixer_tap]'
            :label="`${locales && locales.properties && locales.properties.luxury_mixer_tap} ${kitchen.luxury_mixer_tap.value ? kitchen.luxury_mixer_tap.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.thermostatic_water_mixer.value'
            valid-scope='modal-form'
            name='kitchen[thermostatic_water_mixer]'
            :label="`${locales && locales.properties && locales.properties.thermostatic_water_mixer} ${kitchen.thermostatic_water_mixer.value ? kitchen.thermostatic_water_mixer.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='kitchen.extra_single_cupboard.value'
            valid-scope='modal-form'
            name='kitchen[extra_single_cupboard]'
            :label="`${locales && locales.properties && locales.properties.extra_single_cupboard} ${kitchen.extra_single_cupboard.value ? kitchen.extra_single_cupboard.total : ''}`"
            :precision='0'
            @input='countKitchenPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='kitchen.total'
            valid-scope='modal-form'
            name='kitchen[total]'
            :label='locales && locales.properties && locales.properties.total_kitchen'
            :precision='2'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.sanitary }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model="sanitary['number_of_residents']"
            name='sanitary[number_of_residents]'
            :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
            @input='countSanitaryPoints'
            :IsExtraInfo='true'
          >
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_toilets} ${sanitary.number_of_toilets.value && sanitary.number_of_toilets.total || ''}`"
            v-model='sanitary.number_of_toilets.value'
            name='sanitary[number_of_toilets]'>
          </theme-input>
        </div>
        <div v-if="sanitary.number_of_toilets.value > 0">
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_hunged_toilets} ${sanitary.number_of_hunged_toilets.value && sanitary.number_of_hunged_toilets.total || ''}`"
            v-model='sanitary.number_of_hunged_toilets.value'
            name='sanitary[number_of_hunged_toilets]'>
          </theme-input>
        </div>
        <div v-if="sanitary.number_of_toilets.value > 0">
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_separate_toilets} ${sanitary.number_of_separate_toilets.value && sanitary.number_of_separate_toilets.total || ''}`"
            v-model='sanitary.number_of_separate_toilets.value'
            name='sanitary[number_of_separate_toilets]'>
          </theme-input>
        </div>
        <div>
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_own_toilets} ${sanitary.number_of_own_toilets.value && sanitary.number_of_own_toilets.total || ''}`"
            v-model='sanitary.number_of_own_toilets.value'
            name='sanitary[number_of_own_toilets]'>
          </theme-input>
        </div>
        <div v-if="sanitary.number_of_own_toilets.value > 0">
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_own_hunged_toilets} ${sanitary.number_of_own_hunged_toilets.value && sanitary.number_of_own_hunged_toilets.total || ''}`"
            v-model='sanitary.number_of_own_hunged_toilets.value'
            name='sanitary[number_of_own_hunged_toilets]'>
          </theme-input>
        </div>
        <div v-if="sanitary.number_of_own_toilets.value > 0">
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_own_separate_toilets} ${sanitary.number_of_own_separate_toilets.value && sanitary.number_of_own_separate_toilets.total || ''}`"
            v-model='sanitary.number_of_own_separate_toilets.value'
            name='sanitary[number_of_own_separate_toilets]'>
          </theme-input>
        </div>
        <div>
          <theme-input
            @input='countSanitaryPoints'
            :label="`${locales && locales.properties && locales.properties.number_of_washbasins} ${sanitary.number_of_washbasins.value && sanitary.number_of_washbasins.total || ''}`"
            v-model='sanitary.number_of_washbasins.value'
            name='sanitary[number_of_washbasins]'>
          </theme-input>
        </div>
      </div>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.own_bathroom }}
        </h3>
        <theme-radios
          @input='countSanitaryPoints'
          label=''
          name='sanitary[own_bathroom]'
          v-model='sanitary.own_bathroom'
          :options="{
              '0':
                locales &&
                locales.common &&
                locales.common.no,
              '1':
                locales &&
                locales.common &&
                locales.common.yes
            }">
        </theme-radios>
      </div>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.sanitary }}
          <strong v-if='sanitary.shower_bath.value'>{{ sanitary.shower_bath.total || '' }}</strong>
        </h3>
        <theme-radios
          @input='countSanitaryPoints'
          label=''
          name='sanitary[shower_bath]'
          v-model='sanitary.shower_bath.value'
          :options="{
              '0':
                locales &&
                locales.properties &&
                locales.properties.no_shower_or_bath,
              '1':
                locales &&
                locales.properties &&
                locales.properties.shower_available,
              '2':
                locales &&
                locales.properties &&
                locales.properties.bath_available,
              '3':
                locales &&
                locales.properties &&
                locales.properties.separate_bath_and_shower_in_one_room,
            }">
        </theme-radios>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10'>
        <div>
          <input type='hidden' name='sanitary[cupboard_with_built_in_washbasin]' value='0'/>
          <theme-checkboxes
            id='cupboard_with_built_in_washbasin'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[cupboard_with_built_in_washbasin]'
            v-model='sanitary.cupboard_with_built_in_washbasin.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.cupboard_with_built_in_washbasin} ${sanitary.cupboard_with_built_in_washbasin.value == 1 ? sanitary.cupboard_with_built_in_washbasin.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input type='hidden' name='sanitary[extra_for_a_bubble_bath]' value='0'/>
          <theme-checkboxes
            id='extra_for_a_bubble_bath'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[extra_for_a_bubble_bath]'
            v-model='sanitary.extra_for_a_bubble_bath.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.extra_for_a_bubble_bath} ${sanitary.extra_for_a_bubble_bath.value == 1 ? sanitary.extra_for_a_bubble_bath.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input type='hidden' name='sanitary[mounted_complete_separation_of_shower]' value='0'/>
          <theme-checkboxes
            id='mounted_complete_separation_of_shower'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[mounted_complete_separation_of_shower]'
            v-model='sanitary.mounted_complete_separation_of_shower.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.mounted_complete_separation_of_shower} ${sanitary.mounted_complete_separation_of_shower.value == 1 ? sanitary.mounted_complete_separation_of_shower.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input type='hidden' name='sanitary[towel_radiator]' value='0'/>
          <theme-checkboxes
            id='towel_radiator'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[towel_radiator]'
            v-model='sanitary.towel_radiator.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.towel_radiator} ${sanitary.towel_radiator.value == 1 ? sanitary.towel_radiator.total : ''}` }">
          </theme-checkboxes>
        </div>
        <div>
          <input type='hidden' name='sanitary[power_outlet]' value='0'/>
          <theme-checkboxes
            id='power_outlet'
            @input='countSanitaryPoints'
            label=''
            :is-single-checkbox='true'
            name='sanitary[power_outlet]'
            v-model='sanitary.power_outlet.value'
            :options="{ '1': `${locales && locales.properties && locales.properties.power_outlet}` }">
          </theme-checkboxes>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-numeric
            v-model='sanitary.luxury_mixer_tap.value'
            valid-scope='modal-form'
            name='sanitary[luxury_mixer_tap]'
            :label="`${locales && locales.properties && locales.properties.luxury_mixer_tap} ${sanitary.luxury_mixer_tap.value ? sanitary.luxury_mixer_tap.total : ''}`"
            :precision='0'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='sanitary.thermostatic_water_mixer.value'
            valid-scope='modal-form'
            name='sanitary[thermostatic_water_mixer]'
            :label="`${locales && locales.properties && locales.properties.thermostatic_water_mixer} ${sanitary.thermostatic_water_mixer.value ? sanitary.thermostatic_water_mixer.total : ''}`"
            :precision='0'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
        <div v-if="sanitary.power_outlet.value > 0">
          <theme-numeric
            v-model='sanitary.number_of_power_outlet.value'
            valid-scope='modal-form'
            name='sanitary[number_of_power_outlet]'
            :label="`${locales && locales.properties && locales.properties.number_of_power_outlet} ${sanitary.number_of_power_outlet.value ? sanitary.power_outlet.total : ''}`"
            :precision='0'
            @input='countSanitaryPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='sanitary.total'
            valid-scope='modal-form'
            name='sanitary[total]'
            :label='locales && locales.properties && locales.properties.total_sanitary'
            :precision='2'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.housing_for_disabled }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end'>
        <div>
          <theme-numeric
            v-model='disabled.total_investment.value'
            valid-scope='modal-form'
            name='disabled[total_investment]'
            :label='locales && locales.properties && locales.properties.disabled_total_investment'
            @input='countDisabledPoints'
            :precision='2'>
          </theme-numeric>
        </div>
        <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
          <div>
            <theme-numeric
              v-model="disabled['number_of_residents']"
              name='disabled[number_of_residents]'
              :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
              @input='countDisabledPoints'
              :IsExtraInfo='true'
            >
            </theme-numeric>
          </div>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='disabled.total'
            valid-scope='modal-form'
            name='disabled[total]'
            :label='locales && locales.properties && locales.properties.total_housing_for_disabled'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.private_outdoor_space }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model='outdoor.private_space_area.value'
            valid-scope='modal-form'
            name='outdoor[private_space_area]'
            :label="`${locales && locales.properties && locales.properties.private_outdoor_space}`"
            :precision='2'
            @input='countOutdoorPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='outdoor.common_space_area.value'
            valid-scope='modal-form'
            name='outdoor[common_space_area]'
            :label="`${locales && locales.properties && locales.properties.common_outdoor_space}`"
            :precision='2'
            @input='countOutdoorPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='outdoor.common_outdoor_space_for_multiple_addresses.common_space_addresses'
            valid-scope='modal-form'
            name='outdoor[common_space_addresses]'
            :label="`${locales && locales.properties && locales.properties.common_outdoor_space_addresses}`"
            :precision='0'
            @input='countOutdoorPoints'>
          </theme-numeric>
        </div>
        <div>
            <theme-numeric
              v-model="outdoor.common_space_area.number_of_residents"
              name='outdoor[number_of_residents]'
              :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
              @input='countOutdoorPoints'
              :IsExtraInfo='true'
            >
            </theme-numeric>
          </div>      
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model='outdoor.common_outdoor_space_for_multiple_addresses.value'
            valid-scope='modal-form'
            name='outdoor[common_outdoor_space_for_multiple_addresses]'
            :label="`${locales && locales.properties && locales.properties.common_outdoor_space_for_multiple_addresses}`"
            :precision='2'
            @input='countOutdoorPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='outdoor.common_outdoor_space_for_multiple_addresses.common_space_addresses'
            valid-scope='modal-form'
            name='outdoor[common_outdoor_space_addresses]'
            :label="`${locales && locales.properties && locales.properties.common_space_addresses}`"
            :precision='0'
            @input='countOutdoorPoints'>
          </theme-numeric>
        </div>
        <div>
            <theme-numeric
              v-model="outdoor['number_of_residents']"
              name='outdoor[number_of_residents]'
              :label="`${locales && locales.properties && locales.properties.number_of_residents}`"
              @input='countOutdoorPoints'
              :IsExtraInfo='true'
            >
            </theme-numeric>
          </div>      
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='outdoor.total'
            valid-scope='modal-form'
            name='outdoor[total]'
            :label='locales && locales.properties && locales.properties.total_outdoor'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.shared_indoor_space }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model='indoor.common_departure.value'
            valid-scope='modal-form'
            name='indoor[common_departure]'
            :label="`${locales && locales.properties && locales.properties.common_departure}`"
            :precision='2'
            @input='countIndoorPoints'>
          </theme-numeric>
        </div>
        <div>
            <theme-numeric
              v-model="indoor.common_departure.number_of_addresses"
              name='indoor[number_of_addresses]'
              :label="`${locales && locales.properties && locales.properties.common_indoor_space_addresses}`"
              @input='countIndoorPoints'
              :IsExtraInfo='true'
            >
            </theme-numeric>
          </div>      
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10'>
        <div>
          <theme-numeric
            v-model='indoor.common_other_space.value'
            valid-scope='modal-form'
            name='indoor[common_other_space]'
            :label="`${locales && locales.properties && locales.properties.common_other_space}`"
            :precision='2'
            @input='countIndoorPoints'>
          </theme-numeric>
        </div>
        <div>
          <theme-numeric
            v-model='indoor.common_other_space.common_other_space_addresses'
            valid-scope='modal-form'
            name='indoor[common_other_space_addresses]'
            :label="`${locales && locales.properties && locales.properties.common_other_space_addresses}`"
            :precision='0'
            @input='countIndoorPoints'>
          </theme-numeric>
        </div>    
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='outdoor.total'
            valid-scope='modal-form'
            name='outdoor[total]'
            :label='locales && locales.properties && locales.properties.total_indoor'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.shared_parking }}
      </h2>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.shared_parking }}
        </h3>
        <theme-radios
          v-model='sharedParking.type'
          name='shared_parking[type]'
          :options='sharedParkingOptions'
          @input='countSharedParkingPoints'>
        </theme-radios>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-4 mb-10'>
        <div>
          <theme-numeric
            v-model='sharedParking.number_of_addresses'
            valid-scope='modal-form'
            name='shared_parking[number_of_addresses]'
            :label='locales && locales.properties && locales.properties.number_of_addresses'
            @input='countSharedParkingPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='sharedParking.total'
            valid-scope='modal-form'
            name='shared_parking[total]'
            :label='locales && locales.properties && locales.properties.total_shared_parking'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.vop }}
      </h2>
      <div class='grid grid-cols-1 lg:grid-cols-3 mb-10'>
        <div>
          <a target="_blank" href="https://www.wozwaardeloket.nl">{{locales && locales.common && locales.common.check_here}}</a>
          <theme-numeric
            v-model='vop.price.value'
            valid-scope='modal-form'
            name='vop[price]'
            :label='locales && locales.properties && locales.properties.enter_vop'
            @input='countVopPoints'>
          </theme-numeric>
        </div>
      
        <div>
          <a target="_blank" :href="dependantSettings.price_points_settings.average_vop_prices_link">{{locales && locales.common && locales.common.check_here}}</a>
          <theme-numeric
            v-model='vop.average_price'
            valid-scope='modal-form'
            name='vop[average_price]'
            :label='locales && locales.properties && locales.properties.average_price_per_m2'
            @input='countVopPoints'>
          </theme-numeric>
        </div>
      
        <div>
          <theme-numeric
            v-model='vop.surface'
            valid-scope='modal-form'
            name='vop[surface]'
            :label='locales && locales.properties && locales.properties.surface'
            @input='countVopPoints'>
          </theme-numeric>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='vop.total'
            valid-scope='modal-form'
            name='vop[total]'
            :label='locales && locales.properties && locales.properties.total_vop'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.extra_points }}
      </h2>
      <div class='mb-10'>
        <div class='col-span-6'>
          <h3 class='calculate-price__form-subtitle'>
            {{ locales && locales.properties && locales.properties.care_home }}
          </h3>
          <input type='hidden' name='extra_points[care_home]' value='0'/>
          <theme-checkboxes
            id='careHome'
            @input='countExtraPoints'
            label=''
            :is-single-checkbox='true'
            name='extra_points[care_home]'
            v-model='extraPoints.care_home'
            :options="{ '1': `${locales && locales.properties && locales.properties.care_home}`}">
          </theme-checkboxes>
        </div>
      </div>
      <div class='mb-10'>
        <input type='hidden' name='extra_points[has_automatic_bell]' value='0'/>
        <theme-checkboxes
          id='careHomeBell'
          @input='countExtraPoints'
          label=''
          :is-single-checkbox='true'
          name='extra_points[has_automatic_bell]'
          v-model='extraPoints.has_automatic_bell'
          :options="{ '1': `${locales && locales.properties && locales.properties.has_automatic_bell}`}">
        </theme-checkboxes>
      </div>
      <div class='mb-10'>
        <input type='hidden' name='extra_points[has_charging_station]' value='0'/>
        <theme-checkboxes
          id='chargingStation'
          @input='countExtraPoints'
          label=''
          :is-single-checkbox='true'
          name='extra_points[has_charging_station]'
          v-model='extraPoints.has_charging_station'
          :options="{ '1': `${locales && locales.properties && locales.properties.has_charging_station}`}">
        </theme-checkboxes>
      </div>
      <div class='mb-10'>
        <h3 class='calculate-price__form-subtitle'>
          {{ locales && locales.properties && locales.properties.national_monument }}
        </h3>
        <theme-radios
          :columnDirection='true'
          v-model='extraPoints.national_monument.value'
          name='extra_points[type]'
          :options="{
            '0':
              locales &&
              locales.properties &&
              locales.properties.municipal_or_provincial_monument,
            '1':
              locales &&
              locales.properties &&
              locales.properties.protected_town_and_village_view,
            '2':
              locales &&
              locales.properties &&
              locales.properties.national_monument_before,
            '3':
              locales &&
              locales.properties &&
              locales.properties.national_monument_after,
          }"
          @input='countExtraPoints'>
        </theme-radios>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='extraPoints.total'
            name='extra_points[total]'
            :label='totalLabel(locales && locales.properties && locales.properties.extra_points)'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-section'>
      <h2 class='calculate-price__form-title'>
        {{ locales && locales.properties && locales.properties.deduction_points }}
      </h2>
      <div class='mb-10' v-for='(deduction, index) in deductionOptions'>
        <div class='mb-7' v-if="index != 'total'" :key='index'>
          <input type='hidden' :name='`deduction_points[` + index + `]`' value='0'/>
          <theme-checkboxes
            :id='`deductionOptions`+index'
            @input='countDeductionPoints'
            label=''
            :is-single-checkbox='true'
            :name='`deduction_points[` + index + `]`'
            v-model='deductionOptions[index].value'
            :options="{ '1': `${locales && locales.properties && locales.properties[index]} ${deductionOptions[index].total || ''}` }">
          </theme-checkboxes>
        </div>
      </div>
      <div class='grid grid-cols-1 lg:grid-cols-3'>
        <div>
          <theme-numeric
            v-model='deductionOptions.total'
            name='deduction_points[total]'
            :label='totalLabel(locales && locales.properties && locales.properties.deduction_points_total)'
            :isReadonly='true'>
          </theme-numeric>
        </div>
      </div>
    </div>

    <div class='calculate-price__form-bottom'>
      <div class='default-content grid grid-cols-1 lg:grid-cols-12 items-center gap-1 lg:gap-5'>
        <div class='col-span-2 hidden lg:block'>
          <h3 class='calculate-price__form-bottom-title'>
            {{ this.locales && this.locales.common && this.locales.common.total }}
          </h3>
        </div>
        <div class='lg:col-span-7'>
          <div class='grid grid-cols-2 items-center gap-5'>
            <div class='grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6'>
              <div class='calculate-price__form-bottom-label'>{{ locales && locales.properties && locales.properties.total_points }}</div>
              <div class='lg:hidden'>{{totalPoints || '0'}}</div>
              <div class='hidden lg:block'>
                <theme-numeric
                  v-model='totalPoints'
                  name='total'
                  label=''
                  :isReadonly='true'>
                </theme-numeric>
              </div>
            </div>
            <div class='grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6'>
              <div class='calculate-price__form-bottom-label'>{{locales && locales.properties && locales.properties.max_basic_rent_price }}</div>
              <div class='lg:hidden'>{{price || '0'}}</div>
              <div class='hidden lg:block'>
                <theme-numeric
                  v-model='price'
                  name='price'
                  label=''
                  :isReadonly='true'>
                </theme-numeric>
              </div>
            </div>
          </div>
        </div>
        <div class='lg:col-span-3 grid grid-cols-2 items-center gap-5'>
          <button type='submit' class='theme-btn theme-btn--theme'>
            {{ locales && locales.common && locales.common.download_pdf }}
          </button>
          <button type='submit' name='submit' value='save' class='theme-btn theme-btn--theme'>
            {{ locales && locales.common && locales.common.save }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import _ from 'lodash';
  import $ from 'jquery';

  export default {
    computed: {
      ...mapGetters(['metadata', 'locales']),
    },
    data() {
      return {
        total: 0,
        totalPoints: 0,
        surface: 0,
        price: 0,
      };
    },
    props: {
      property: {
        default: () => {
          return {};
        },
        type: Object,
      },
      kitchenFacilities: {
        default: () => {
          return {};
        },
        type: Object,
      },
      extraPoints: {
        default: () => {
          return {};
        },
        type: Object,
      },
      leaveArea: {
        default: () => {
          return {};
        },
        type: Object,
      },
      heating: {
        default: () => {
          return {};
        },
        type: Object,
      },
      dependantMaxRentalPrices: {
        default: () => {
          return {};
        },
        type: [Array, Object],
      },
      kitchenOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      wcOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      bathShowerOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      washbasinOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      outdoorSpaceOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      bicycleShedOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      deductionOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      dependantSettings: {
        default: () => {
          return {};
        },
        type: [Array, Object],
      },
      otherSpaces: {
        default: () => {
          return {};
        },
        type: Object,
      },
      kitchen: {
        default: () => {
          return {};
        },
        type: Object,
      },
      sanitary: {
        default: () => {
          return {};
        },
        type: Object,
      },
      outdoor: {
        default: () => {
          return {};
        },
        type: Object,
      },
      indoor: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energy: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabels: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsCustomOrder: {
        default: () => {
          return {};
        },
        type: [Object, Array],
      },
      outdoorSpacesCustomOrder: {
        default: () => {
          return {};
        },
        type: [Object, Array],
      },
      energyLabels: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsBySlug: {
        default: () => {
          return {};
        },
        type: Object,
      },
      energyLabelsIdBySlug: {
        default: () => {
          return {};
        },
        type: Object,
      },
      disabled: {
        default: () => {
          return {};
        },
        type: Object,
      },
      dependantLandlordSpendingsBase: {
        default: 0,
        type: [String, Number],
      },
      sharedParking: {
        default: () => {
          return {};
        },
        type: Object,
      },
      sharedParkingOptions: {
        default: () => {
          return {};
        },
        type: Object,
      },
      vop: {
        default: () => {
          return {};
        },
        type: Object,
      },


    },
    beforeMount() {
      this.countDependantLeaveAreaPoints(this.leaveArea);
      this.countDependantOtherSpacesAreaPoints(this.otherSpaces);
      this.countHeatingPoints();
      this.countEnergyPoints();
      this.countKitchenPoints();
      this.countSanitaryPoints();
      this.countDisabledPoints();
      this.countOutdoorPoints();
      this.countIndoorPoints();
      this.countSharedParkingPoints();
      this.countExtraPoints();
      this.countDeductionPoints();
    },
    methods: {
      countDependantLeaveAreaPoints(object) {
        var sum = 0;
        var commonAreaPoints = 0;
        var commonAreaSurface = 0;
        var tenantSurface = 0;
        if (object["own_room"].surface) {
          sum +=
            Math.round(
              parseFloat((object["own_room"].surface + "").replace(",", "."))
            ) * parseFloat((this.dependantSettings.price_points_settings.dependant_leave_area.own_room_points_per_m2 + "").replace(",", "."));
            tenantSurface += parseFloat((object["own_room"].surface + "").replace(",", "."));
        }
        if (
          object["common_area"].surface
        ) {
          commonAreaSurface += Math.round(
            parseFloat((object["common_area"].surface + "").replace(",", "."))
          );
        }

        if (object["number_of_residents"] && object["number_of_residents"] >= 1) {
          commonAreaPoints =
            Math.round(
              commonAreaSurface /
                parseFloat((object["number_of_residents"] + "").replace(",", "."))
            ) * parseFloat((this.dependantSettings.price_points_settings.dependant_leave_area.common_area_points_per_m2 + "").replace(",", "."));
          sum += commonAreaPoints;

          tenantSurface += Math.round(commonAreaSurface / parseFloat((object["number_of_residents"] + "").replace(",", ".")));
        }
        this.surface = tenantSurface;
        var total = sum;
        Vue.set(object, "total", total);
        this.countDependantTotal();
      },

      countDependantOtherSpacesAreaPoints(object) {
        var sum = 0;
        var commonAreaPoints = 0;
        var commonAreaSurface = 0;
        if (object["private_other_spaces"].surface) {
          sum +=
            Math.round(
              parseFloat((object["private_other_spaces"].surface + "").replace(",", "."))
            ) * parseFloat((this.dependantSettings.price_points_settings.dependant_other_spaces_area.private_area_points_per_m2 + "").replace(",", "."));
        }
        if (
          object["common_other_spaces_area"].surface
        ) {
          commonAreaSurface += Math.round(
            parseFloat((object["common_other_spaces_area"].surface + "").replace(",", "."))
          );
        }

        if (object["number_of_residents"] && object["number_of_residents"] >= 1) {
          commonAreaPoints =
            Math.round(
              commonAreaSurface /
                parseFloat((object["number_of_residents"] + "").replace(",", "."))
            ) * parseFloat((this.dependantSettings.price_points_settings.dependant_other_spaces_area.common_area_points_per_m2 + "").replace(",", "."));
          sum += commonAreaPoints;
        }
        var total = sum;
        Vue.set(object, "total", total);
        this.countDependantTotal();
      },

      countHeatingPoints() {
        var sum = 0;
        
        var privateRoomsHeatingPoints =
            parseFloat(this.heating.private_rooms_with_heating.value + "") *
            parseFloat((this.dependantSettings.price_points_settings.dependant_heating.own_room + "").replace(",", "."));
        sum += privateRoomsHeatingPoints;
        Vue.set(this.heating.private_rooms_with_heating, "total", privateRoomsHeatingPoints);

        var sharedRoomsHeatingPoints = 0;
        if(parseFloat(this.heating.shared_rooms_with_heating.value + "") > 0 &&  parseFloat(this.heating.number_of_residents + "") > 0){
          sharedRoomsHeatingPoints = Math.round((parseFloat(this.heating.shared_rooms_with_heating.value + "") *
              (parseFloat((this.dependantSettings.price_points_settings.dependant_heating.common_room + "").replace(",", ".")) / parseFloat(this.heating.number_of_residents + "")) + Number.EPSILON) * 100) / 100;
        }
        sum += sharedRoomsHeatingPoints;
        Vue.set(this.heating.shared_rooms_with_heating, "total", sharedRoomsHeatingPoints);

        var privateRoomsCoolingPoints =
            parseFloat(this.heating.private_rooms_with_cooling.value + "") *
            parseFloat((this.dependantSettings.price_points_settings.dependant_heating.own_room_cooling + "").replace(",", "."));
        var privateCoolingMaxPoints = parseFloat((this.dependantSettings.price_points_settings.dependant_heating.own_room_max_cooling + "").replace(",", "."));
        if(privateRoomsCoolingPoints > privateCoolingMaxPoints){
          privateRoomsCoolingPoints = privateCoolingMaxPoints;
        }
        sum += privateRoomsCoolingPoints;
        Vue.set(this.heating.private_rooms_with_cooling, "total", privateRoomsCoolingPoints);

        var sharedRoomsCoolingPoints = 0;
        if(parseFloat(this.heating.shared_rooms_with_cooling.value + "") > 0 &&  parseFloat(this.heating.number_of_residents + "") > 0){
          sharedRoomsCoolingPoints = Math.round((parseFloat(this.heating.shared_rooms_with_cooling.value + "") *
              (parseFloat((this.dependantSettings.price_points_settings.dependant_heating.common_room_cooling + "").replace(",", ".")) / parseFloat(this.heating.number_of_residents + "")) + Number.EPSILON) * 100) / 100;
        }
        var sharedCoolingMaxPoints = parseFloat((this.dependantSettings.price_points_settings.dependant_heating.common_room_max_cooling + "").replace(",", "."));
        if(sharedRoomsCoolingPoints > sharedCoolingMaxPoints){
          sharedRoomsCoolingPoints = sharedCoolingMaxPoints;
        }
        sum += sharedRoomsCoolingPoints;
        Vue.set(this.heating.shared_rooms_with_cooling, "total", sharedRoomsCoolingPoints);

        var privateOtherSpacesHeatingPoints =
            parseFloat(this.heating.private_other_spaces_with_heating.value + "") *
            parseFloat((this.dependantSettings.price_points_settings.dependant_heating.other_own_room + "").replace(",", "."));
        sum += privateOtherSpacesHeatingPoints;
        Vue.set(this.heating.private_other_spaces_with_heating, "total", privateOtherSpacesHeatingPoints);

        var sharedOtherSpacesHeatingPoints = 0;
        if(parseFloat(this.heating.shared_other_spaces_with_heating.value + "") > 0 &&  parseFloat(this.heating.number_of_other_spaces_residents + "") > 0){
          sharedOtherSpacesHeatingPoints = Math.round((parseFloat(this.heating.shared_other_spaces_with_heating.value + "") *
              (parseFloat((this.dependantSettings.price_points_settings.dependant_heating.other_common_room + "").replace(",", ".")) / parseFloat(this.heating.number_of_other_spaces_residents + "")) + Number.EPSILON) * 100) / 100;
        }
        sum += sharedOtherSpacesHeatingPoints;
        Vue.set(this.heating.shared_other_spaces_with_heating, "total", sharedOtherSpacesHeatingPoints);
          
        var total = sum;
        Vue.set(this.heating, "total", total);
        this.countDependantTotal();
      },
      countEnergyPoints() {
        var sum = 0;
        var energyPoints = 0;
        if(this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] != "no_label_or_index"){
          energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[this.energy.energy_label].points_per_m2+'').replace(',', '.'));
        }else if (this.energy.energy_label && this.energyLabels[this.energy.energy_label] && this.energyLabels[this.energy.energy_label]["slug"] == "no_label_or_index" && this.energy.building_construction_year) {
          if (this.energy.building_construction_year <= 1976) {
            var labelG = this.energyLabelsIdBySlug["label_g"];
            energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelG].points_per_m2+'').replace(',', '.'));
          } else if (this.energy.building_construction_year <= 1978) {
            var labelF = this.energyLabelsIdBySlug["label_f"];
              energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelF].points_per_m2+'').replace(',', '.'));
          } else if (this.energy.building_construction_year <= 1983) {
            var labelE = this.energyLabelsIdBySlug["label_e"];
              energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelE].points_per_m2+'').replace(',', '.'));
          } else if (this.energy.building_construction_year <= 1991) {
            var labelD = this.energyLabelsIdBySlug["label_d"];
              energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelD].points_per_m2+'').replace(',', '.'));
          } else if (this.energy.building_construction_year <= 1999) {
            var labelC = this.energyLabelsIdBySlug["label_c"];
              energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelC].points_per_m2+'').replace(',', '.'));
          } else if (this.energy.building_construction_year <= 2001) {
            var labelB = this.energyLabelsIdBySlug["label_b"];
            energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelB].points_per_m2+'').replace(',', '.'));
          } else if (this.energy.building_construction_year > 2001) {
            var labelA = this.energyLabelsIdBySlug["label_a"];
            energyPoints = parseFloat((this.dependantSettings.price_points_settings.energy[labelA].points_per_m2+'').replace(',', '.'));
          }
        }
        if (this.energy.monument_allowance && this.energy.monument_allowance == 1 && energyPoints < 0) {
          energyPoints = 0;
        }
        energyPoints = energyPoints * this.surface;
        sum += energyPoints;
        var total = sum;
        Vue.set(this.energy, "energy_points", total);
        Vue.set(this.energy, "total", total);
        this.countDependantTotal();
      },
      countKitchenPoints() {
        var sum = 0;
        var maxPoints = 0;
        var addPoints = 0;
        var residents = parseFloat((this.kitchen.number_of_residents + "").replace(",", "."));
        if (this.kitchen.worktop_length.value == 2) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_1_2m_points + "").replace(",", ".")); //4
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_1_2m_max_points + "").replace(",", ".")); //8
          
        } else if (this.kitchen.worktop_length.value == 3) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_2_3m_points + "").replace(",", ".")); //7
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_2_3m_max_points + "").replace(",", ".")); //14
        } else if (this.kitchen.worktop_length.value == 4) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_3m_points + "").replace(",", ".")); //7
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_3m_max_points + "").replace(",", ".")); //14
        } else if (this.kitchen.worktop_length.value == 5) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_5m_points + "").replace(",", ".")); //7
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.kitchen.worktop_5m_max_points + "").replace(",", ".")); //14
        }
        Vue.set(this.kitchen.worktop_length, "points", addPoints);
        Vue.set(this.kitchen.worktop_length, "total", addPoints);
        sum += addPoints;
        if(residents > 0){
          sum = sum / residents;
        }
        for (var ob in this.kitchen) {
          var element = this.kitchen[ob];
          var points = 0;
          if (ob == "cooker") {
            if (element.value == 1) {
              points = parseFloat((this.dependantSettings.price_points_settings.kitchen.gas_cooker_points + "").replace(",", ".")); //0.5
            } else if (element.value == 2) {
              points = parseFloat((this.dependantSettings.price_points_settings.kitchen.ceramic_cooker_points + "").replace(",", ".")); //1
            } else if (element.value == 3) {
              points = parseFloat((this.dependantSettings.price_points_settings.kitchen.induction_cooker_points + "").replace(",", ".")); //1.25
            }
            Vue.set(this.kitchen[ob], "total", points);
          } else if (ob == "oven") {
            if (element.value == 1) {
              points = parseFloat((this.dependantSettings.price_points_settings.kitchen.gas_oven_points + "").replace(",", ".")); //0.75
            } else if (element.value == 2) {
              points = parseFloat((this.dependantSettings.price_points_settings.kitchen.electric_oven_points + "").replace(",", ".")); //1.25
            }
            Vue.set(this.kitchen[ob], "total", points);
          } else if (ob != "total" && ob != "worktop_length" && ob != "number_of_residents") {
            points = parseFloat((element.points + "").replace(",", ".")) * Math.round(parseFloat((element.value + "").replace(",", ".")));
            Vue.set(this.kitchen[ob], "total", points);
          }
          if(residents > 0){
            points = points / residents;
          }
          if (sum + points <= maxPoints) {
            sum += points;
          } else {
            sum = maxPoints;
          }
        }
        
        var total = sum;
        Vue.set(this.kitchen, "total", total);
        this.countDependantTotal();
      },
      countSanitaryPoints() {
        var sum = 0;
        var maxPoints = 0;
        var addPoints = 0;
        var toiletPoints = 0;
      
        if (this.sanitary.shower_bath.value == 1) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.sanitary.shower_points +'').replace(',', '.')); //4
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.sanitary.shower_max_points +'').replace(',', '.')); //8
        } else if (this.sanitary.shower_bath.value == 2) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.sanitary.bath_points +'').replace(',', '.')); //6
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.sanitary.bath_max_points +'').replace(',', '.')); //12
        } else if (this.sanitary.shower_bath.value == 3) {
          addPoints = parseFloat((this.dependantSettings.price_points_settings.sanitary.shower_bath_points +'').replace(',', '.')); //7
          maxPoints = parseFloat((this.dependantSettings.price_points_settings.sanitary.shower_bath_max_points +'').replace(',', '.')); //14
        }
        Vue.set(this.sanitary.shower_bath, "points", addPoints);
        Vue.set(this.sanitary.shower_bath, "total", addPoints);
        sum += addPoints;

        if (this.sanitary.number_of_toilets.value) {
          var p = parseFloat((this.sanitary.number_of_toilets.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_toilets.value + "").replace(",", ".")));
          maxPoints += p;
          toiletPoints += p;
          Vue.set(this.sanitary.number_of_toilets, "total", p);
        }
        if (this.sanitary.number_of_hunged_toilets.value) {
          var p = parseFloat((this.sanitary.number_of_hunged_toilets.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_hunged_toilets.value + "").replace(",", ".")));
          maxPoints += p;
          toiletPoints += p;
          Vue.set(this.sanitary.number_of_hunged_toilets, "total", p);
        }
        if (this.sanitary.number_of_washbasins.value) {
          var p = parseFloat((this.sanitary.number_of_washbasins.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_washbasins.value + "").replace(",", ".")));
          maxPoints += p;
          toiletPoints += p;
          Vue.set(this.sanitary.number_of_washbasins, "total", p);
        }
        for (var ob in this.sanitary) {
          var element = this.sanitary[ob];
          var points = 0;
          if (ob == "power_outlet") {
            points = this.sanitary.number_of_power_outlet.value * parseFloat((element.points+'').replace(',', '.'));
            if(points > parseFloat((this.dependantSettings.price_points_settings.sanitary.power_outlet_max_points+ "").replace(",", "."))){
              points = parseFloat((this.dependantSettings.price_points_settings.sanitary.power_outlet_max_points+ "").replace(",", "."));
            }
            Vue.set(this.sanitary[ob], "total", points);
          } else if (ob == "number_of_separate_toilets") {
            if(parseFloat((this.sanitary.number_of_toilets.value+'').replace(',', '.')) < parseFloat((this.sanitary.number_of_separate_toilets.value+'').replace(',', '.'))){
              var nt =  this.sanitary.number_of_toilets.value;
              Vue.set(this.sanitary.number_of_separate_toilets, "value", nt);
            }
            points = -(parseFloat((this.sanitary.number_of_toilets.value+'').replace(',', '.')) - parseFloat((this.sanitary.number_of_separate_toilets.value+'').replace(',', '.'))) * parseFloat((element.points+'').replace(',', '.'));
            
            Vue.set(this.sanitary[ob], "total", points);
          } else if (
            ob != "total" &&
            ob != "number_of_toilets" &&
            ob != "number_of_hunged_toilets" &&
            ob != "number_of_residents" &&
            ob != "number_of_separate_toilets" &&
            ob != "number_of_own_toilets" &&
            ob != "number_of_own_separate_toilets" &&
            ob != "number_of_own_hunged_toilets" &&
            ob != "number_of_washbasins" &&
            ob != "number_of_power_outlet" &&
            ob != "shower_bath" &&
            ob != "own_bathroom"
          ) {
              points = parseFloat((element.points+'').replace(',', '.')) * Math.round(parseFloat((element.value + "").replace(",", ".")));
              Vue.set(this.sanitary[ob], "total", points);
          }
          if (sum + points <= maxPoints) {
            sum += points;
          } else {
            sum = maxPoints;
          }
        }
        
        var residents = this.sanitary.number_of_residents ? Math.round(parseFloat((this.sanitary.number_of_residents + "").replace(",", "."))) : 0;
        if(residents > 0){
          toiletPoints = toiletPoints / residents;
          if(this.sanitary.own_bathroom == 0 || this.sanitary.own_bathroom === null){
            sum = sum / residents;
          }
          sum += toiletPoints;
        }else{
          toiletPoints = 0;
          if(this.sanitary.own_bathroom == 0 || this.sanitary.own_bathroom === null){
            sum = 0;
          }
        }
        if (this.sanitary.number_of_own_toilets.value) {
          var p = parseFloat((this.sanitary.number_of_own_toilets.points+'').replace(',', '.')) * Math.round(parseFloat((this.sanitary.number_of_own_toilets.value + "").replace(",", ".")));
          sum += p;
          Vue.set(this.sanitary.number_of_own_toilets, "total", p);
        }
        if (this.sanitary.number_of_own_separate_toilets.value) {
          if(parseFloat((this.sanitary.number_of_own_toilets.value+'').replace(',', '.')) < parseFloat((this.sanitary.number_of_own_separate_toilets.value+'').replace(',', '.'))){
            var nt =  this.sanitary.number_of_own_toilets.value;
            Vue.set(this.sanitary.number_of_own_separate_toilets, "value", nt);
          }
          points = -(parseFloat((this.sanitary.number_of_own_toilets.value+'').replace(',', '.')) - parseFloat((this.sanitary.number_of_own_separate_toilets.value+'').replace(',', '.'))) * parseFloat((this.sanitary['number_of_own_separate_toilets'].points+'').replace(',', '.'));
          sum += points;
          Vue.set(this.sanitary['number_of_own_separate_toilets'], "total", points);
        }
        if (this.sanitary.number_of_own_hunged_toilets.value) {
          if(parseFloat((this.sanitary.number_of_own_toilets.value+'').replace(',', '.')) < parseFloat((this.sanitary.number_of_own_hunged_toilets.value+'').replace(',', '.'))){
            var nt =  this.sanitary.number_of_own_toilets.value;
            Vue.set(this.sanitary.number_of_own_hunged_toilets, "value", nt);
          }
          points = -(parseFloat((this.sanitary.number_of_own_toilets.value+'').replace(',', '.')) - parseFloat((this.sanitary.number_of_own_hunged_toilets.value+'').replace(',', '.'))) * parseFloat((this.sanitary['number_of_own_hunged_toilets'].points+'').replace(',', '.'));
          sum += points;
          Vue.set(this.sanitary['number_of_own_hunged_toilets'], "total", points);
        }
        var total = sum;
        Vue.set(this.sanitary, "total", total);
        this.countDependantTotal();
      },
      countDisabledPoints() {
        var sum = 0;
        var maxPoints = 0;
        if (this.disabled.total_investment.value && parseFloat((this.disabled.total_investment.value + "").replace(",", ".")) > 0) {
          var p = parseFloat((this.disabled.total_investment.points + "").replace(",", ".")) * Math.floor(parseFloat((this.disabled.total_investment.value + "").replace(",", ".") / this.dependantLandlordSpendingsBase));
          sum += p;
          Vue.set(this.disabled.total_investment, "total", p);
        }

        var residents = this.disabled.number_of_residents ? Math.round(parseFloat((this.disabled.number_of_residents + "").replace(",", "."))) : 0;
        if(residents > 0){
          sum = sum / residents;
        }else{
          sum =0;
        }
        var total = sum;
        Vue.set(this.disabled, "total", total);
        this.countDependantTotal();
      },
      countOutdoorPoints() {
        var sum = 0;      
        if (this.outdoor.private_space_area.value && parseFloat((this.outdoor.private_space_area.value + "").replace(",", ".")) > 0) {
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.min_space_points+'').replace(",", ".")) + parseFloat((this.outdoor.private_space_area.value + "").replace(",", ".")) * parseFloat((this.dependantSettings.price_points_settings.outdoor.space_points+'').replace(",", "."));
          // Vue.set(this.outdoor.space, "points", points);
          Vue.set(this.outdoor.private_space_area, "total", points);
          sum += points;
        }
        if (this.outdoor.common_space_area.value && parseFloat((this.outdoor.common_space_area.value + "").replace(",", ".")) > 0 && parseFloat((this.outdoor.common_space_area.number_of_residents + "").replace(",", ".")) > 0) {
          var p = (parseFloat((this.outdoor.common_space_area.value + "").replace(",", ".")) * parseFloat((this.dependantSettings.price_points_settings.outdoor.common_space_points+'').replace(",", ".")))/parseFloat((this.outdoor.common_space_area.number_of_residents + "").replace(",", "."));
          // Vue.set(this.outdoor.common_space, "points", p);
          Vue.set(this.outdoor.common_space_area, "total", p);
          sum += p;
        }
        if (this.outdoor.common_outdoor_space_for_multiple_addresses.value && parseFloat((this.outdoor.common_outdoor_space_for_multiple_addresses.value + "").replace(",", ".")) > 0 && parseFloat((this.outdoor.common_outdoor_space_for_multiple_addresses.common_space_addresses + "").replace(",", ".")) > 0) {
          var p = (parseFloat((this.outdoor.common_outdoor_space_for_multiple_addresses.value + "").replace(",", ".")) * parseFloat((this.dependantSettings.price_points_settings.outdoor.common_space_for_multiple_addresses_points+'').replace(",", ".")))/parseFloat((this.outdoor.common_outdoor_space_for_multiple_addresses.common_space_addresses + "").replace(",", "."));
          // Vue.set(this.outdoor.common_space, "points", p);
          Vue.set(this.outdoor.common_outdoor_space_for_multiple_addresses, "total", p);
          sum += p;
        }
        var maxPoints = parseFloat((this.dependantSettings.price_points_settings.outdoor.max_space_points+'').replace(",", "."));
        if(sum > maxPoints){
          sum = maxPoints;
        }
        var total = sum;
        Vue.set(this.outdoor, "total", total);

        this.countDependantTotal();
      },
      countIndoorPoints() {
        var sum = 0; 
        if (this.indoor.common_departure && this.indoor.common_departure.value && parseFloat((this.indoor.common_departure.value + "").replace(",", ".")) > 0 && parseFloat((this.indoor.common_departure.number_of_addresses + "").replace(",", ".")) > 0) {
          var p = (parseFloat((this.indoor.common_departure.value + "").replace(",", ".")) * parseFloat((this.dependantSettings.price_points_settings.common_indoor_shared_with_multiple_addresses.common_departure_points+'').replace(",", ".")))/parseFloat((this.indoor.common_departure.number_of_addresses + "").replace(",", "."));
          // Vue.set(this.indoor.common_space, "points", p);
          Vue.set(this.indoor.common_departure, "total", p);
          sum += p;
        }
        if (this.indoor.common_other_space && this.indoor.common_other_space.value && parseFloat((this.indoor.common_other_space.value + "").replace(",", ".")) > 0 && parseFloat((this.indoor.common_other_space.common_other_space_addresses + "").replace(",", ".")) > 0) {
          var p = (parseFloat((this.indoor.common_other_space.value + "").replace(",", ".")) * parseFloat((this.dependantSettings.price_points_settings.common_indoor_shared_with_multiple_addresses.common_other_space_points+'').replace(",", ".")))/parseFloat((this.indoor.common_other_space.common_other_space_addresses + "").replace(",", "."));
          // Vue.set(this.indoor.common_space, "points", p);
          Vue.set(this.indoor.common_other_space, "total", p);
          sum += p;
        }
        var total = sum;
        Vue.set(this.indoor, "total", total);

        this.countDependantTotal();
      },
      countSharedParkingPoints() {
        var points = 0;
        if(parseFloat((this.sharedParking.number_of_addresses+'').replace(",", ".")) > 0){
          points = parseFloat((this.dependantSettings.price_points_settings.shared_parking[this.sharedParking.type]+'').replace(',', '.')) / parseFloat((this.sharedParking.number_of_addresses+'').replace(",", "."));
        }
        Vue.set(this.sharedParking, "total", points);
        this.countDependantTotal();
      },
      countVopPoints() {
        var sum = 0;
        var price = this.vop.price.value;
        var points = 0;
        var pointsPerSurface = 0;
        if (price) {
          if (this.vop.surface > 0) {
            pointsPerSurface = (parseFloat((price+'').replace(',', '.')) / parseFloat((this.vop.surface+'').replace(',', '.')));
          }
        }
        var averagePrice = parseFloat((this.vop.average_price+'').replace(',', '.'));
        if(pointsPerSurface > 0){
          if(pointsPerSurface > (1.1 * averagePrice)){
            points = parseFloat((this.dependantSettings.price_points_settings.vop.higher_than_10+'').replace(',', '.'));
          }else if(pointsPerSurface >= (0.9 * averagePrice) && pointsPerSurface <= (1.1 * averagePrice)){
            points = parseFloat((this.dependantSettings.price_points_settings.vop.not_lower_than_10_and_not_higher_than_10+'').replace(',', '.'));
          }else if(pointsPerSurface < (0.9 * averagePrice)){
            points = parseFloat((this.dependantSettings.price_points_settings.vop.lower_than_10+'').replace(',', '.'));
          }
        }
        var total = points;
        var total = Math.round(total);
        Vue.set(this.vop, "total", total);

        this.countDependantTotal();
      },
      countExtraPoints() {
        var sum = 0;
        if (
          this.extraPoints.care_home &&
          this.extraPoints.care_home == 1
        ) {
          var points =
            parseFloat(this.leaveArea.total+"") +
            parseFloat(this.otherSpaces.total+"") +
            parseFloat(this.heating.total+"") +
            parseFloat(this.energy.total+"") +
            parseFloat(this.kitchen.total+"") +
            parseFloat(this.sanitary.total+"") +
            parseFloat(this.disabled.total+"") +
            parseFloat(this.outdoor.total+"") +
            parseFloat(this.indoor.total+"") +
            parseFloat(this.sharedParking.total+"") +
            parseFloat(this.vop.total+"");
            sum += points * ((parseFloat((this.dependantSettings.price_points_settings.care_home.points+'').replace(",", ".")))/100);
        }
        if (this.extraPoints.has_automatic_bell && this.extraPoints.has_automatic_bell == 1) {
          sum += parseFloat((this.dependantSettings.price_points_settings.care_home.automatic_bell_points+'').replace(",", "."));
        }
        if (this.extraPoints.has_charging_station && this.extraPoints.has_charging_station == 1) {
          sum += parseFloat((this.dependantSettings.price_points_settings.care_home.charging_station+'').replace(",", "."));
        }
        this.countDependantTotal();
        if (this.extraPoints.national_monument.value) {
          switch(this.extraPoints.national_monument.value){
            case '0':
              var p = (parseFloat((this.dependantSettings.price_points_settings.monument.municipal_or_provincial_monument_percentage+'').replace(",", "."))/100) * this.price;
              this.price = this.price + p;
              break;
            case '1':
              var p = (parseFloat((this.dependantSettings.price_points_settings.monument.protected_town_and_village_view_percentage+'').replace(",", "."))/100) * this.price;
              this.price = this.price + p;
              break;
            case '2':
              var p = (parseFloat((this.dependantSettings.price_points_settings.monument.protected_town_and_village_view_percentage+'').replace(",", ".")));
              sum += p;
              break;
            case '3':
              var p = (parseFloat((this.dependantSettings.price_points_settings.monument.national_monument_percentage+'').replace(",", "."))/100) * this.price;
              this.price = this.price + p;
              break;
          }
        }
        var total = sum;
        Vue.set(this.extraPoints, "total", total);
        this.countDependantTotal();
      },
      countDeductionPoints() {
        var sum = 0;

        if(this.surface > 0 && this.surface < 8){
          sum -= parseFloat(this.dependantSettings.price_points_settings.deduction.small_area_negative_points+"");
        }
        for (var ob in this.deductionOptions) {
          if (ob != "total") {
            if (this.deductionOptions[ob].value && parseFloat(this.deductionOptions[ob].value + "")) {
              sum -= parseFloat(this.deductionOptions[ob].points + "");
              Vue.set(
                this.deductionOptions[ob],
                "total",
                - parseFloat(this.deductionOptions[ob].points + "")
              );
            } else {
              Vue.set(this.deductionOptions[ob], "total", 0);
            }
          }
        }
        var total = sum;
        Vue.set(this.deductionOptions, "total", total);
        this.countDependantTotal();
      },
      countDependantTotal() {
          var total =
          parseFloat(this.leaveArea.total+"") +
          parseFloat(this.otherSpaces.total+"") +
          parseFloat(this.heating.total+"") +
          parseFloat(this.energy.total+"") +
          parseFloat(this.kitchen.total+"") +
          parseFloat(this.sanitary.total+"") +
          parseFloat(this.disabled.total+"") +
          parseFloat(this.outdoor.total+"") +
          parseFloat(this.indoor.total+"") +
          parseFloat(this.sharedParking.total+"") +
          parseFloat(this.vop.total+"") +
          parseFloat(this.extraPoints.total+"") +
          parseFloat(this.deductionOptions.total+"");
        this.total = Math.round(total);
        this.totalPoints = this.total;
        var p = this.totalPoints < 750 ? this.totalPoints : 750;
        this.price = this.dependantMaxRentalPrices[p];
      },
      totalLabel(text) {
        let addText = this.locales && this.locales.common && this.locales.common.total;
        if (text && addText) {
          return `${text} ${addText}`;
        }
        if (text) {
          return text;
        }
        if (addText) {
          return addText;
        }
        return '---';
      },
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/DependantFormNew.vue